import { Vehicle } from "../Vehicle/Vehicle";
import { Trip } from "../Trip/Trip";
import { TripWaitTime } from "./TripWaitTime";
import * as moment from 'moment';

export class VehicleReservation {

    tripsAndWaitTimes: Array<TripWaitTime> = [];
    vehicle: Vehicle;

    constructor(vehicle: Vehicle) {

        this.vehicle = vehicle;
    }

    addTrip(trip: Trip) {

        this.tripsAndWaitTimes.push(new TripWaitTime(trip));
    }


    //Assign A Trip To The Vehicle Reservation and decides wheter it is being added as a return trip or if assignment is immediate
    public assignToNewTrip(trip: Trip) {

        var waitTime = 0;
        
        if (this.vehicle.remainingSeats >= trip.passengers.length) {
            waitTime = 0;
        } else {

            if (this.vehicle.capacity >= trip.passengers.length) {
                waitTime = this.getWaitTime(trip);
            } else {
                throw new Error("Can't wait for this vehicle not enough seat capacity");
            }
        }

        if (waitTime > 0) {//Reservation for return trip

            if (this.vehicle.capacity >= trip.passengers.length) {
                this.addTrip(trip);
                trip.vehicleReservation = this;
            } else {
                throw new Error("Could not reserve vehicle for trip: vehicle capacity not enough");
            }

        } else {//Imediate assignment so seats are taken

            if (this.vehicle.remainingSeats >= trip.passengers.length) {
                this.vehicle.remainingSeats -= trip.passengers.length;
                this.addTrip(trip);
                trip.vehicleReservation = this;
            } else {
                throw new Error("Can't assign trip to vehicle: not enough remaining seats");
            }
        }
    }

    public assignAsReturnTrip(trip: Trip) {

        if (this.vehicle.capacity >= trip.passengers.length) {
            this.addTrip(trip);
            trip.vehicleReservation = this;
        } else {
            throw new Error("Could not reserve vehicle for trip: vehicle capacity not enough");
        }
    }

    getTripReturnTime(trip: Trip) {
        
        return this.getTripDepartTime(trip).add(trip.time, 's');
    }

    //Calculates the actual depart time of the trip(parameter)
    getTripDepartTime(trip: Trip) {
        var t = this.tripsAndWaitTimes.find(t => t.tripId == trip.id);
        if (t != null) {
            var index = this.tripsAndWaitTimes.indexOf(t);
            if (index == 0) {
                return moment(t.time).add(trip.loadTime,'m');
            }
        } else {
            return moment(trip.reportDate).add(trip.loadTime,'m');
        }

        var departTime = moment(this.tripsAndWaitTimes[0].time).add(trip.loadTime,'m');
        departTime.add(this.tripsAndWaitTimes[0].tripTime, 's');

        for (var i = 1; i < this.tripsAndWaitTimes.length; i++) {

            var nextTripDepartTime = moment(this.tripsAndWaitTimes[i].time)/*.add(trip.loadTime,'m')*/;

            if (departTime.isBefore(nextTripDepartTime)) {
                departTime = moment(nextTripDepartTime.toString());
            }

            if (this.tripsAndWaitTimes[i].tripId == t.tripId) {

                return departTime.add(trip.loadTime,'m');
            }

            departTime.add(this.tripsAndWaitTimes[i].tripTime, 's');
        }

        return departTime.add(trip.loadTime,'m');
    }


    /**
     *Get The Time The Vehicle Will Be Available after completing the given trip(parameter)
     */
    getTimeVehicleWillBeAvailableAfterTrip(trip: Trip,lastTrip = false): moment.Moment {

        var t = null;

        if(lastTrip){
            t = this.tripsAndWaitTimes[(this.tripsAndWaitTimes.length-1)];
        }else{
            t = this.tripsAndWaitTimes.find(t => t.tripId == trip.id);
        }
        if (t != null) {
            var index = this.tripsAndWaitTimes.indexOf(t);
            if (index == 0) {
                return moment(t.time).add(t.tripTime, 's');
            }
        } else {
            return null;
        }

        var returnTime = moment(this.tripsAndWaitTimes[0].time);
        returnTime.add(this.tripsAndWaitTimes[0].tripTime, 's');

        for (var i = 1; i < this.tripsAndWaitTimes.length; i++) {

            var nextTripDepartTime = moment(this.tripsAndWaitTimes[i].time);

            if (returnTime.isBefore(nextTripDepartTime)) {
                returnTime = moment(nextTripDepartTime.toString());
            }

            returnTime.add(this.tripsAndWaitTimes[i].tripTime, 's');

            if (this.tripsAndWaitTimes[i].tripId == t.tripId) {

                return returnTime;
            }
        }

        return returnTime;
    }

    //Calculates The Difference between when a trip was meant to depart and when it actually departs.
    //Example Should Leave 2:00 AM But Left 2:20 AM This would return the 20 Minute Difference in seconds.
    getWaitTime(trip: Trip) {
        //try{
            var departs = this.getTripDepartTime(trip);
            var waitTIme = departs.diff(moment(trip.slotTime), 's', true);
            return waitTIme;
        /*}catch(e){
            console.log(e);
            return 0;
        }*/
    }

    //Calculates the difference in time for when a trip has to wait until they are picked up by a return vehicle
    getTimeVehicleWillBeAvailableForTripAfterLastTrip(trip:Trip){

        //try{
            var time = this.getTimeVehicleWillBeAvailableAfterTrip(null,true);
            var diff = time.diff(moment(trip.slotTime),'s',true);
            return diff; 
        /*}catch(e){
            console.log(e);
            return 0;
        }*/
    }

}